import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { LtxEntry } from '../../../station-reports.types';

export function UnverifiedLtxEntriesTable({ data }: { data: LtxEntry[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<LtxEntry>($t, {
          accessor: (row) => row.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<LtxEntry>($t, {
          accessor: (row) => row.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'name',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name',
            defaultMessage: 'Nombre',
          }),
          accessorKey: 'name',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'type',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type',
            defaultMessage: 'Tipo',
          }),
          accessorKey: 'type',
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'equals',
          size: 120,
        },
      ]}
    />
  );
}
